jQuery(function($) {

  console.log("Quiz loaded!")

  // Which quiz sections should be wrapped
const TARGET_SELECTORS = [
  '.oct-quiz-wrapper.oct-quiz-wrapper--collect-text',
  '.oct-quiz-wrapper.oct-quiz-wrapper--explainer',
  '.oct-quiz-wrapper.oct-quiz-wrapper--picture-choice',
  '.oct-quiz-wrapper.oct-quiz-wrapper--multiple-choice',
  '.oct-quiz-wrapper.oct-quiz-wrapper--multiplechoice',
  '.oct-quiz-wrapper.oct-quiz-wrapper--multi-choice'
];

  const answeredQuestionKeys = new Set();

  function getQuizStepTitle(step) {
    return (step && step.querySelector('.oct-quiz-title')?.textContent || '').trim().toLowerCase();
  }

  function getPictureChoiceQuestionKey(step) {
    const title = getQuizStepTitle(step);
    const progress = (step && step.querySelector('.oct-quiz-bottom_content .oct-quiz-subheading')?.textContent || '').trim().toLowerCase();
    return `${title}|${progress}`;
  }

  function isAutoAdvanceExplainer(step) {
    const title = getQuizStepTitle(step);
    return !!(step && step.classList.contains('oct-quiz-wrapper--explainer') && title.includes('finding seeds'));
  }

  function isStepVisible(step) {
    if (!step) return false;
    const displayElements = step.querySelectorAll('[data-display]');
    if (displayElements.length === 0) return true;
    return !!step.querySelector('[data-display="oct-display"]');
  }

  function updateQuizStepState(root = document) {
    const quiz = root.querySelector('.quiz-2026-page .octane-ai-quiz-rendered');
    if (!quiz) return;

    const explainer = quiz.querySelector('.oct-quiz-wrapper--explainer');
    const explainerHasLoader = !!(explainer && explainer.querySelector('.auto-loader'));
    const explainerHasImage = !!(explainer && explainer.querySelector('.oct-quiz-top_content img'));
    const autoAdvanceExplainer = isAutoAdvanceExplainer(explainer);
    const email = quiz.querySelector('.oct-quiz-wrapper--email');
    const emailIsVisible = isStepVisible(email);
    const resultPage = quiz.querySelector('.oct-quiz-wrapper--result-page');
    const pictureChoice = quiz.querySelector('.oct-quiz-wrapper--picture-choice');
    const multipleChoice = quiz.querySelector('.oct-quiz-wrapper--multiple-choice, .oct-quiz-wrapper--multiplechoice, .oct-quiz-wrapper--multi-choice, [data-element*="oct-quiz-multiplechoice"]');
    const questionStep = !!(pictureChoice || multipleChoice);

    quiz.classList.toggle('quiz-2026-step--collect-text', !!quiz.querySelector('.oct-quiz-wrapper--collect-text'));
    quiz.classList.toggle('quiz-2026-step--explainer', !!explainer);
    quiz.classList.toggle('quiz-2026-step--interstitial-explainer', explainerHasLoader && !autoAdvanceExplainer);
    quiz.classList.toggle('quiz-2026-step--auto-advance-explainer', autoAdvanceExplainer);
    quiz.classList.toggle('quiz-2026-step--interstitial-has-octane-image', explainerHasLoader && explainerHasImage && !autoAdvanceExplainer);
    quiz.classList.toggle('quiz-2026-step--interstitial-fallback-image', explainerHasLoader && !explainerHasImage && !autoAdvanceExplainer);
    quiz.classList.toggle('quiz-2026-step--email', !!email);
    quiz.classList.toggle('quiz-2026-step--email-ready', emailIsVisible);
    quiz.classList.toggle('quiz-2026-step--results', !!resultPage);
    quiz.classList.toggle('quiz-2026-step--question', questionStep);
    quiz.classList.toggle('quiz-2026-step--picture-choice', !!pictureChoice);
  }

  function enhancePictureChoiceStep(root = document) {
    root.querySelectorAll('.quiz-2026-page .oct-quiz-wrapper--picture-choice').forEach((step) => {
      const contentWrapper = step.querySelector(':scope > .oct-quiz-content') || step;
      const outerWrapper = step.closest('#octane-quiz-wrapper');
      const backButton = outerWrapper && outerWrapper.querySelector(':scope > .oct-quiz-btn--primary-text, :scope > .oct-quiz-btn--small');
      const options = Array.from(step.querySelectorAll('.oct-quiz-picture-choice-options__option'));
      const questionKey = getPictureChoiceQuestionKey(step);
      const getCurrentQuestionKey = () => step.dataset.quiz2026QuestionKey || getPictureChoiceQuestionKey(step);
      const hasCurrentQuestionSelection = () => answeredQuestionKeys.has(getCurrentQuestionKey());

      step.dataset.quiz2026QuestionKey = questionKey;
      step.classList.toggle('quiz-2026-has-user-selection', answeredQuestionKeys.has(questionKey));

      options.forEach((option) => {
        if (!option.dataset.quiz2026Label) {
          option.dataset.quiz2026Label = option.getAttribute('aria-label') || option.getAttribute('title') || '';
        }

        const label = option.dataset.quiz2026Label.toLowerCase();
        if (label.includes('confident')) {
          option.style.order = '1';
        } else if (label.includes('big dreams')) {
          option.style.order = '2';
        } else if (label.includes('win some')) {
          option.style.order = '3';
        }
      });

      if (!answeredQuestionKeys.has(questionKey)) {
        options.forEach((option) => {
          option.setAttribute('aria-checked', 'false');
          option.classList.remove('quiz-2026-selected-option');
          option.style.color = '';
        });
      }

      let actions = contentWrapper.querySelector(':scope > .quiz-2026-question-actions');
      if (!actions) {
        actions = document.createElement('div');
        actions.className = 'quiz-2026-question-actions';
        contentWrapper.appendChild(actions);
      }

      if (backButton && backButton.parentElement !== actions) {
        backButton.textContent = 'Back';
        actions.appendChild(backButton);
      }

      let nextButton = actions.querySelector('.quiz-2026-question-next');
      if (!nextButton) {
        nextButton = document.createElement('button');
        nextButton.type = 'button';
        nextButton.className = 'oct-quiz-btn oct-quiz-btn--primary quiz-2026-question-next';
        nextButton.textContent = 'Next';
        actions.appendChild(nextButton);
      }

      let dots = contentWrapper.querySelector(':scope > .quiz-2026-progress-dots');
      if (!dots) {
        dots = document.createElement('div');
        dots.className = 'quiz-2026-progress-dots';
        dots.setAttribute('aria-hidden', 'true');
        dots.innerHTML = '<span></span><span></span><span></span><span></span><span></span>';
        contentWrapper.appendChild(dots);
      }

      const questionText = step.querySelector('.oct-quiz-bottom_content .oct-quiz-subheading')?.textContent || '';
      const questionMatch = questionText.match(/(\d+)\s*\/\s*(\d+)/);
      const activeDotIndex = questionMatch ? Number(questionMatch[1]) : 1;
      Array.from(dots.children).forEach((dot, index) => {
        dot.classList.toggle('is-active', index === activeDotIndex);
      });

      const syncNextButton = () => {
        const hasUserSelection = hasCurrentQuestionSelection();
        const hasSelection = hasUserSelection && !!step.querySelector('.oct-quiz-picture-choice-options__option[aria-checked="true"], .oct-quiz-picture-choice-options__option.quiz-2026-selected-option');
        step.classList.toggle('quiz-2026-has-user-selection', hasUserSelection);
        nextButton.disabled = !hasSelection;
        nextButton.setAttribute('aria-disabled', hasSelection ? 'false' : 'true');
      };

      const markUserSelection = (option) => {
        answeredQuestionKeys.add(getCurrentQuestionKey());
        step.classList.add('quiz-2026-has-user-selection');
        options.forEach((item) => item.classList.toggle('quiz-2026-selected-option', item === option));
        window.setTimeout(syncNextButton, 0);
      };

      if (!nextButton.dataset.quiz2026Bound) {
        nextButton.addEventListener('click', () => {
          const selectedOption = hasCurrentQuestionSelection()
            ? step.querySelector('.oct-quiz-picture-choice-options__option[aria-checked="true"]')
            : null;
          if (selectedOption) selectedOption.click();
        });
        nextButton.dataset.quiz2026Bound = '1';
      }

      if (!step.dataset.quiz2026OptionBound) {
        options.forEach((option) => {
          option.addEventListener('pointerdown', () => markUserSelection(option));
          option.addEventListener('click', () => markUserSelection(option));
          option.addEventListener('keyup', (event) => {
            if (event.key === 'Enter' || event.key === ' ') {
              markUserSelection(option);
            }
          });
        });
        step.dataset.quiz2026OptionBound = '1';
      }

      syncNextButton();
    });
  }

  function enhanceExplainerVisuals(root = document) {
    root.querySelectorAll('.quiz-2026-page .oct-quiz-wrapper--explainer').forEach((step) => {
      const titleEl = step.querySelector('.oct-quiz-title');
      const title = getQuizStepTitle(step);
      const contentWrapper = step.querySelector(':scope > .oct-quiz-content') || step;
      const topContent = step.querySelector('.oct-quiz-top_content');
      const hasOctaneImage = !!(topContent && topContent.querySelector('img'));
      const isFindingSeeds = title.includes('finding seeds');
      const isInterstitial = isFindingSeeds || !!step.querySelector('.auto-loader');
      const quiz = step.closest('.octane-ai-quiz-rendered');

      if (!titleEl || !isInterstitial) return;

      step.classList.toggle('quiz-2026-inner-auto-advance-explainer', isFindingSeeds);
      if (quiz && isFindingSeeds) {
        quiz.classList.add('quiz-2026-step--explainer', 'quiz-2026-step--auto-advance-explainer');
      }

      let loader = step.querySelector('.auto-loader');
      if (!loader) {
        loader = document.createElement('div');
        loader.className = 'auto-loader';
      }

      if (!hasOctaneImage && !contentWrapper.querySelector(':scope > .quiz-2026-interstitial-image')) {
        const image = document.createElement('div');
        image.className = 'quiz-2026-interstitial-image';
        contentWrapper.insertBefore(image, loader.parentElement === contentWrapper ? loader : titleEl.nextSibling);
      }

      const imageAnchor = hasOctaneImage
        ? topContent
        : contentWrapper.querySelector(':scope > .quiz-2026-interstitial-image');

      if (imageAnchor) {
        imageAnchor.classList.add('quiz-2026-interstitial-image-frame');
      }

      if (imageAnchor && imageAnchor.nextSibling !== loader) {
        contentWrapper.insertBefore(loader, imageAnchor.nextSibling);
      } else if (!imageAnchor && titleEl.nextSibling !== loader) {
        contentWrapper.insertBefore(loader, titleEl.nextSibling);
      }
    });
  }

  function enhanceExplainerBackButtons(root = document) {
    root.querySelectorAll('.quiz-2026-page .octane-ai-quiz-rendered.quiz-2026-step--explainer').forEach((quiz) => {
      const explainer = quiz.querySelector('.oct-quiz-wrapper--explainer');
      const contentWrapper = explainer && (explainer.querySelector(':scope > .oct-quiz-content') || explainer);
      const actions = contentWrapper && contentWrapper.querySelector(':scope > .quiz-btns-wrapper');
      const outerWrapper = quiz.querySelector('#octane-quiz-wrapper');
      const isInterstitial = !!(
        explainer &&
        (
          quiz.classList.contains('quiz-2026-step--interstitial-explainer') ||
          quiz.classList.contains('quiz-2026-step--auto-advance-explainer') ||
          explainer.querySelector('.auto-loader') ||
          isAutoAdvanceExplainer(explainer)
        )
      );
      const backButton = quiz.querySelector('#octane-quiz-wrapper > .oct-quiz-btn--primary-text, #octane-quiz-wrapper > .oct-quiz-btn--small, .oct-quiz-wrapper--explainer .quiz-btns-wrapper > .oct-quiz-btn--primary-text, .oct-quiz-wrapper--explainer .quiz-btns-wrapper > .oct-quiz-btn--small');
      if (backButton) {
        if (isInterstitial) {
          if (outerWrapper && backButton.parentElement !== outerWrapper) {
            outerWrapper.appendChild(backButton);
          }
          backButton.classList.add('quiz-2026-hidden-interstitial-back');
          backButton.setAttribute('aria-hidden', 'true');
          backButton.setAttribute('tabindex', '-1');
          return;
        }

        backButton.classList.remove('quiz-2026-hidden-interstitial-back');
        backButton.removeAttribute('aria-hidden');
        backButton.setAttribute('tabindex', '0');

        if (backButton.textContent.trim() !== 'Back') {
          backButton.textContent = 'Back';
        }

        if (actions && backButton.parentElement !== actions) {
          actions.insertBefore(backButton, actions.firstElementChild);
        }

        if (backButton.dataset.quiz2026ExplainerBackBound !== '1') {
          backButton.dataset.quiz2026ExplainerBackBound = '1';
        }
      }
    });
  }

  function normalizeQuizButtonText(root = document) {
    const labels = {
      'NEXT': 'Next',
      'START QUIZ': 'Start Quiz',
      'CONTINUE': 'Continue',
      'SEND FREE LIST': 'Send Free List',
      'NO THANKS, SHOW ME MY SEEDS!': 'No thanks, show me my seeds!'
    };

    root.querySelectorAll('.quiz-2026-page .oct-quiz-btn').forEach((button) => {
      const currentLabel = button.textContent.trim();
      if (labels[currentLabel]) {
        button.textContent = labels[currentLabel];
      }
    });
  }

   /**
   * Ensure each target section has its children wrapped in `.oct-quiz-content`.
   * - Idempotent (won’t double-wrap)
   * - Safe across re-renders and back/forward nav
   */
  function ensureQuizSectionWrapped({
  root = document,
  selectors = TARGET_SELECTORS,
  contentWrapperClass = 'oct-quiz-content',
  buttonWrapperClass = 'quiz-btns-wrapper'
} = {}) {
  selectors.forEach((sel) => {
    root.querySelectorAll(sel).forEach((el) => {
      if (isAutoAdvanceExplainer(el)) return;

      // --- STEP 1: wrap section content in .oct-quiz-content ---
      const firstEl = el.firstElementChild;
      let contentWrapper;
      if (firstEl && firstEl.classList.contains(contentWrapperClass)) {
        contentWrapper = firstEl;
      } else if (el.dataset.octWrapped !== '1') {
        contentWrapper = document.createElement('div');
        contentWrapper.className = contentWrapperClass;
        while (el.firstChild) contentWrapper.appendChild(el.firstChild);
        el.appendChild(contentWrapper);
        el.dataset.octWrapped = '1';
      } else {
        contentWrapper = el.querySelector(`:scope > .${contentWrapperClass}`);
        if (!contentWrapper) return;
      }

      // --- STEP 2: wrap all quiz buttons in .quiz-btns-wrapper ---
      const contentButtons = Array.from(contentWrapper.children).filter(child => child.classList.contains('oct-quiz-btn-wrapper'));
      const siblingButtons = [];
      let nextSibling = el.nextElementSibling;
      while (nextSibling && nextSibling.classList.contains('oct-quiz-btn-wrapper')) {
        siblingButtons.push(nextSibling);
        nextSibling = nextSibling.nextElementSibling;
      }
      const buttons = [...contentButtons, ...siblingButtons];
      if (buttons.length > 0) {
        let alreadyWrapped = contentWrapper.querySelector(`.${buttonWrapperClass}`);
        if (!alreadyWrapped) {
          console.log('wrapping buttons');
          alreadyWrapped = document.createElement('div');
          alreadyWrapped.className = buttonWrapperClass;
          contentWrapper.appendChild(alreadyWrapped);
        }

        // move this step's .oct-quiz-btn nodes to the new wrapper
        buttons.forEach(btn => alreadyWrapped.appendChild(btn));
      }

      const primaryButton = contentWrapper.querySelector('.oct-quiz-wrapper--explainer .oct-quiz-btn--primary, .oct-quiz-btn--primary');
      if (el.classList.contains('oct-quiz-wrapper--explainer') && primaryButton && ['start quiz', 'continue'].includes(primaryButton.textContent.trim().toLowerCase())) {
        primaryButton.textContent = 'Next';
      }
    });
  });

  enhanceExplainerVisuals(root);
  updateQuizStepState(root);
  normalizeQuizButtonText(root);
  enhanceExplainerBackButtons(root);
  enhancePictureChoiceStep(root);
}

    // wrap as soon as the step appears (cheap + idempotent)
    // ensureQuizSectionWrapped();

    function insertAfter(referenceNode, newNode) {
      referenceNode.parentNode.insertBefore(newNode, referenceNode.nextSibling);
    }

    //RANDOMLY SORT PRODUCT BLOCKS ON RESULT PAGE
    const randomiseFlexOrder = querySelector => {
      [...querySelector].map((c,i,a) => c.style.order = Math.floor(Math.random() * a.length + 1));
    };

    const products = [["All Products","https://www.westcoastseeds.com/collections/vegetable-seeds"],["Cucamelon", "https://www.westcoastseeds.com/products/cucamelon"], ["Rainbow Blend", "https://www.westcoastseeds.com/products/rainbow-blend"]];
    const productsObj = [
      {
        collectionHandle: "sprouting",
        links:[
          ["All Sprouting Products","https://www.westcoastseeds.com/collections/sprouting"],
          ["Sprouting Jar with Metal Lid and Seeds", "https://www.westcoastseeds.com/products/sprouting-jar-metal-lid-seeds"],
          ["Sandwich Booster Mix Organic", "https://www.westcoastseeds.com/products/special-mix-organic"],
          ["Alfalfa Sprouting Seeds Organic", "https://www.westcoastseeds.com/products/alfalfa-sprouting-seeds-organic"],
          ["Red Radish Organic", "https://www.westcoastseeds.com/products/red-radish-organic"],
          ["Go Go Sprouting Seeds Organic", "https://www.westcoastseeds.com/products/a-go-go-sprouting-seeds-organic"]
        ]
      },
      {
        collectionHandle: "kale-seeds",
        links:[
          ["All Kale Products","https://www.westcoastseeds.com/collections/kale-seeds"],
          ["Rainbow Lacinato Organic", "https://www.westcoastseeds.com/products/rainbow-tuscan-organic"], 
          ["Red Russian", "https://www.westcoastseeds.com/products/red-russian"],
          ["Winterbor ", "https://www.westcoastseeds.com/products/winterbor"],
          ["Darkibor Coated", "https://www.westcoastseeds.com/products/darkibor"],
          ["Lacinato Organic ", "https://www.westcoastseeds.com/products/lacinato-organic"]
        ]
      },
      {
        collectionHandle: "tomato-seeds",
        links:[
          ["All Tomato Products","https://www.westcoastseeds.com/collections/tomato-seeds"],
          ["Indigo Rose Organic", "https://www.westcoastseeds.com/products/indigo-rose-organic"],
          ["Sakura Organic", "https://www.westcoastseeds.com/products/sakura-organic"],
          ["Black Krim Organic", "https://www.westcoastseeds.com/products/black-krim-organic"],
          ["Tumbler", "https://www.westcoastseeds.com/products/tumbler-tomato-seeds"],
          ["Early Girl", "https://www.westcoastseeds.com/products/early-girl"]
        ]
      },
      {
        collectionHandle: "microgreens-seeds",
        links:[
          ["All Microgreen Products","https://www.westcoastseeds.com/collections/microgreens-seeds"],
          ["SunBlaster T5HO Mini Greenhouse Kit", "https://www.westcoastseeds.com/products/mini-greenhouse-indoor-growing-kit"],
          ["Microgreen Pea Shoots", "https://www.westcoastseeds.com/products/microgreen-pea-shoot-seeds"],
          ["Microgreen Mustard Seeds", "https://www.westcoastseeds.com/products/microgreen-mustard-seeds"],
          ["Two Week Microgreen Seeds", "https://www.westcoastseeds.com/products/two-week-microgreen-seeds"],
          ["SunBlaster T5H0 Growlight Garden", "https://www.westcoastseeds.com/products/growlight-garden-5"]
        ]
      },
      {
        collectionHandle: "cucumber-seeds",
        links:[
          ["All Cucumber Products","https://www.westcoastseeds.com/collections/cucumber-seeds"],
          ["Patio Snacker", "https://www.westcoastseeds.com/products/patio-snacker"],
          ["Mercury Cucumber", "https://www.westcoastseeds.com/products/mercury"],
          ["Tasty Green Cucumber", "https://www.westcoastseeds.com/products/tasty-green"],
          ["Cucuamelon", "https://www.westcoastseeds.com/products/cucamelon"],
          ["Tyria Organic", "https://www.westcoastseeds.com/products/tyria-organic"]
        ]
      },
      {
        collectionHandle: "mustard-seeds",
        links:[
          ["All Mustard Green Products","https://www.westcoastseeds.com/collections/mustard-seeds"],
          ["Osaka Purple", "https://www.westcoastseeds.com/products/osaka-purple"],
          ["Stir Fry Blend", "https://www.westcoastseeds.com/products/stir-fry"],
          ["Mizuna Organic", "https://www.westcoastseeds.com/products/mizuna-organic"],
          ["Komatsuna Green", "https://www.westcoastseeds.com/products/komatsuna-green"],
          ["Tokyo Bekana", "https://www.westcoastseeds.com/products/tokyo-bekana-mustard-seeds"]
        ]
      },
      {
        collectionHandle: "carrot-seeds",
        links:[
          ["All Carrot Products","https://www.westcoastseeds.com/collections/carrot-seeds"],
          ["Rainbow Blend", "https://www.westcoastseeds.com/products/rainbow-blend"],
          ["Bolero", "https://www.westcoastseeds.com/products/bolero"],
          ["Ya Ya Coated Organic", "https://www.westcoastseeds.com/products/ya-ya-organic"],
          ["Deep Purple Coated", "https://www.westcoastseeds.com/products/deep-purple"],
          ["Royal Chantenay", "https://www.westcoastseeds.com/products/royal-chantenay"]
        ]
      },
      {
        collectionHandle: "arugula-seeds",
        links:[
          ["All Arugula Products","https://www.westcoastseeds.com/collections/arugula-seeds"],
          ["Astro Organic", "https://www.westcoastseeds.com/products/astro-organic"],
          ["Dragon’s Fire", "https://www.westcoastseeds.com/products/dragons-fire"],
          ["Bellezia Organic", "https://www.westcoastseeds.com/products/bellezia-organic"],
          ["Selvatica Organic", "https://www.westcoastseeds.com/products/selvatica-organic"],
          ["Alfresco Pelleted", "https://www.westcoastseeds.com/products/alfresco"]
        ]
      },
      {
        collectionHandle: "squash-seeds",
        links:[
          ["All Squash Products","https://www.westcoastseeds.com/collections/squash-seeds"],
          ["Sunburst", "https://www.westcoastseeds.com/products/sunburst"],
          ["First Taste Kabocha", "https://www.westcoastseeds.com/products/first-taste-kabocha"],
          ["Table Queen", "https://www.westcoastseeds.com/products/table-queen"],
          ["Tiana Butternut Organic", "https://www.westcoastseeds.com/products/tiana-butternut"],
          ["Tromboncino", "https://www.westcoastseeds.com/products/tromboncino"]
        ]
      },
      {
        collectionHandle: "bush-beans",
        links:[
          ["All Bush Bean Products","https://www.westcoastseeds.com/collections/bush-beans"],
          ["Celine Certified Organic", "https://www.westcoastseeds.com/products/celine-certified-organic"],
          ["Goliath", "https://www.westcoastseeds.com/products/goliath-f26"],
          ["Gold Rush", "https://www.westcoastseeds.com/products/gold-rush-2"],
          ["Tricolour Bean Blend", "https://www.westcoastseeds.com/products/tricolor-bean-blend"],
          ["Masai Bush Bean", "https://www.westcoastseeds.com/products/masai-french"]
        ]
      },
      {
        collectionHandle: "pole-beans",
        links:[
          ["All Bush Bean Products","https://www.westcoastseeds.com/collections/pole-beans"],
          ["Kentucky Blue", "https://www.westcoastseeds.com/products/kentucky-blue"],
          ["Fortex Filet", "https://www.westcoastseeds.com/products/fortex-filet"],
          ["Matilda", "https://www.westcoastseeds.com/products/matilda"],
          ["Blue Lake", "https://www.westcoastseeds.com/products/blue-lake"],
          ["Purple Peacock", "https://www.westcoastseeds.com/products/purple-peacock"]
        ]
      },
      {
        collectionHandle: "swiss-chard-seeds",
        links:[
          ["All Swiss Chard Products","https://www.westcoastseeds.com/collections/swiss-chard-seeds"],
          ["Magenta Sunset", "https://www.westcoastseeds.com/products/magenta-sunset"],
          ["Peppermint Chard", "https://www.westcoastseeds.com/products/peppermint"],
          ["Rhubarb Chard", "https://www.westcoastseeds.com/products/rhubarb-chard"],
          ["Silverado", "https://www.westcoastseeds.com/products/silverado"],
          ["Canary Yellow", "https://www.westcoastseeds.com/products/canary-yellow"]
        ]
      },
      {
        collectionHandle: "turnip-seeds",
        links:[
          ["All Turnip Products","https://www.westcoastseeds.com/collections/turnip-seeds"],
          ["Hakurei", "https://www.westcoastseeds.com/products/hakurei"],
          ["Purple Top White Globe", "https://www.westcoastseeds.com/products/purple-top-white-globe"],
          ["Silky Sweet", "https://www.westcoastseeds.com/products/silky-sweet"],
          ["Tokyo Cross", "https://www.westcoastseeds.com/products/tokyo-cross"],
          ["Purple Prince", "https://www.westcoastseeds.com/products/purple-prince"]
        ]
      },
      {
        collectionHandle: "corn-seeds",
        links:[
          ["All Corn Products","https://www.westcoastseeds.com/collections/corn-seeds"],
          ["Golden Bantam", "https://www.westcoastseeds.com/products/golden-bantam"],
          ["Jubilee Super Sweet", "https://www.westcoastseeds.com/products/jubilee-super-sweet"],
          ["Calico Popcorn", "https://www.westcoastseeds.com/products/calico-popcorn"],
          ["Glass Gem Organic", "https://www.westcoastseeds.com/products/glass-gem-organic"],
          ["Pink Popcorn", "https://www.westcoastseeds.com/products/pink-popcorn"]
        ]
      },
      {
        collectionHandle: "artichoke-seeds",
        links:[
          ["All Artichoke Products","https://www.westcoastseeds.com/collections/artichoke-seeds"],
          ["Imperial Star Organic", "https://www.westcoastseeds.com/products/imperial-star-organic-2"],
          ["Cardoon", "https://www.westcoastseeds.com/products/cardoon-2"],
          ["Green Globe", "https://www.westcoastseeds.com/products/green-globe"]
        ]
      },
      {
        collectionHandle: "pepper-seeds",
        links:[
          ["All Pepper Products","https://www.westcoastseeds.com/collections/pepper-seeds"],
          ["Red Candy Cane", "https://www.westcoastseeds.com/products/red-candy-cane"],
          ["Mad Hatter", "https://www.westcoastseeds.com/products/mad-hatter"],
          ["Purple Beauty", "https://www.westcoastseeds.com/products/purple-beauty"],
          ["Oranos Organic", "https://www.westcoastseeds.com/products/oranos-organic"],
          ["Orange You Sweet", "https://www.westcoastseeds.com/products/orange-you-sweet"]
        ]
      },
      {
        collectionHandle: "hot-peppers",
        links:[
          ["All Hot Pepper Products","https://www.westcoastseeds.com/collections/hot-peppers"],
          ["Spicy Slice", "https://www.westcoastseeds.com/products/spicy-slice"],
          ["Trinidad Morunga Scorpion", "https://www.westcoastseeds.com/products/trinidad-moruga-scorpion"],
          ["Pepperoncini", "https://www.westcoastseeds.com/products/pepperoncini"],
          ["Large Thick Cayenne", "https://www.westcoastseeds.com/products/large-cayenne"],
          ["Habanero", "https://www.westcoastseeds.com/products/habanero"]
        ]
      },
      {
        collectionHandle: "melon-seeds",
        links:[
          ["All Melon Products","https://www.westcoastseeds.com/collections/melon-seeds"],
          ["Tirreno Organic", "https://www.westcoastseeds.com/products/tirreno-organic"],
          ["Divergent Organic", "https://www.westcoastseeds.com/products/divergent-organic"],
          ["Black Beauty Mini Watermelon", "https://www.westcoastseeds.com/products/black-beauty-mini-watermelon"],
          ["Yellow Doll", "https://www.westcoastseeds.com/products/yellow-doll"],
          ["Home Run", "https://www.westcoastseeds.com/products/home-run"]
        ]
      },
      {
        collectionHandle: "strawberry-seeds",
        links:[
          ["All Strawberry Products","https://www.westcoastseeds.com/collections/strawberry-seeds"],
          ["Yellow Wonder Alpine", "https://www.westcoastseeds.com/products/yellow-wonder-alpine"],
          ["Fresca Strawberry", "https://www.westcoastseeds.com/products/fresca-strawberry-seeds"],
          ["Regina", "https://www.westcoastseeds.com/products/regina"]
        ]
      },
      {
        collectionHandle: "asparagus-seeds",
        links:[
          ["All Asparagus Products","https://www.westcoastseeds.com/collections/asparagus-seeds"],
          ["Guelph Millennium", "https://www.westcoastseeds.com/products/guelph-millennium"],
          ["Voltaire Asparagus", "https://www.westcoastseeds.com/products/voltaire-asparagus"]
        ]
      },
      {
        collectionHandle: "eggplant-seeds",
        links:[
          ["All Eggplant Products","https://www.westcoastseeds.com/collections/eggplant-seeds"],
          ["Ping Tung Long", "https://www.westcoastseeds.com/products/ping-tung-long"],
          ["Piccolo", "https://www.westcoastseeds.com/products/piccolo"],
          ["Listada de Grandia Organic", "https://www.westcoastseeds.com/products/listada-de-gandia-certified-organic"],
          ["Traviata Organic", "https://www.westcoastseeds.com/products/traviata-organic"],
          ["Long Purple", "https://www.westcoastseeds.com/products/fingerling-long-purple"]
        ]
      },
      {
        collectionHandle: "lettuce-seeds",
        links:[
          ["All Lettuce Products","https://www.westcoastseeds.com/collections/lettuce-seeds"],
          ["Buttercrunch", "https://www.westcoastseeds.com/products/buttercrunch"],
          ["Red Salad Bowl", "https://www.westcoastseeds.com/products/red-salad-bowl"],
          ["Drunken Woman Lettuce Organic", "https://www.westcoastseeds.com/products/drunken-woman-lettuce-organic"],
          ["Simpson Elite", "https://www.westcoastseeds.com/products/simpson-elite"],
          ["Speckled Butterhead Organic", "https://www.westcoastseeds.com/products/speckled-butterhead-organic"]
        ]
      },
      {
        collectionHandle: "herb-seeds",
        links:[
          ["All Herbs Products","https://www.westcoastseeds.com/collections/herb-seeds"],
          ["Sweet Basil", "https://www.westcoastseeds.com/products/sweet-basil"],
          ["Genovese Organic", "https://www.westcoastseeds.com/products/genovese-organic"],
          ["Piccolino Organic", "https://www.westcoastseeds.com/products/piccolino-organic"],
          ["Forest Green Parsley", "https://www.westcoastseeds.com/products/forest-green"],
          ["Santo Organic", "https://www.westcoastseeds.com/products/santo-organic"]
        ]
      },
      {
        collectionHandle: "pea-seeds",
        links:[
          ["All Pea Products","https://www.westcoastseeds.com/collections/pea-seeds"],
          ["Super Sugar Snap", "https://www.westcoastseeds.com/products/super-sugar"],
          ["Alderman Tall Telephone", "https://www.westcoastseeds.com/products/alderman-tall-telephone"],
          ["Purple Mist Organic", "https://www.westcoastseeds.com/products/blue-delft"],
          ["Green Arrow", "https://www.westcoastseeds.com/products/green-arrow"],
          ["Dwarf Grey Sugar", "https://www.westcoastseeds.com/products/dwarf-grey-sugar"]
        ]
      },
      {
        collectionHandle: "cabbage-seeds",
        links:[
          ["All Cabbage Products","https://www.westcoastseeds.com/collections/pea-seeds"],
          ["Integro Organic", "https://www.westcoastseeds.com/products/integro-organic"],
          ["Tiara Coated", "https://www.westcoastseeds.com/products/tiara"],
          ["Deadon Coated Organic", "https://www.westcoastseeds.com/products/deadon"],
          ["Kalibos", "https://www.westcoastseeds.com/products/kalibos"],
          ["Consul", "https://www.westcoastseeds.com/products/consul"]
        ]
      },
      {
        collectionHandle: "cilantro-seeds",
        links:[
          ["All Cilantro Products","https://www.westcoastseeds.com/collections/cilantro-seeds"],
          ["Santo Organic", "https://www.westcoastseeds.com/products/santo-organic"],
          ["Calypso", "https://www.westcoastseeds.com/products/calypso"],
          ["Santo Long Standing", "https://www.westcoastseeds.com/products/santo-long-standing"]
        ]
      },
      {
        collectionHandle: "chive-seeds",
        links:[
          ["All Chive Products","https://www.westcoastseeds.com/collections/chive-seeds"],
          ["Chives", "https://www.westcoastseeds.com/products/chives"],
          ["Chives Organic", "https://www.westcoastseeds.com/products/chives-organic"],
          ["Lion’s Mane", "https://www.westcoastseeds.com/products/lions-mane"],
          ["Garlic Chives", "https://www.westcoastseeds.com/products/garlic-chives"]
        ]
      },
      {
        collectionHandle: "cress-seeds",
        links:[
          ["All Watercress Products","https://www.westcoastseeds.com/collections/cress-seeds"],
          ["True Watercress", "https://www.westcoastseeds.com/products/watercress"],
          ["Curly Cress Peppergrass", "https://www.westcoastseeds.com/products/peppergrass-curly-cress"]
        ]
      },
      {
        collectionHandle: "onion-seeds",
        links:[
          ["All Onion Products","https://www.westcoastseeds.com/collections/onion-seeds"],
          ["Patterson", "https://www.westcoastseeds.com/products/patterson"],
          ["Zebrune", "https://www.westcoastseeds.com/products/zebrune"],
          ["Cabernet", "https://www.westcoastseeds.com/products/cabernet-organic"],
          ["Borettana", "https://www.westcoastseeds.com/products/borettana"],
          ["Kelsae", "https://www.westcoastseeds.com/products/kelsae"]
        ]
      },
      {
        collectionHandle: "cauliflower-seeds",
        links:[
          ["All Cauliflower Products","https://www.westcoastseeds.com/collections/cauliflower-seeds"],
          ["Skywalker Organic", "https://www.westcoastseeds.com/products/skywalker-organic"],
          ["Sunset", "https://www.westcoastseeds.com/products/sunset"],
          ["Adona F1 Organic", "https://www.westcoastseeds.com/products/adona-f1-coated-certified-organic"],
          ["Amazing", "https://www.westcoastseeds.com/products/amazing-cauliflower-seeds"],
          ["Walcheren Winter", "https://www.westcoastseeds.com/products/walcheren-winter"]
        ]
      }
    ]

    //RUN ON RESULTS PAGE
    document.addEventListener('octane.quiz.completed', function (e) {
        // your code for building and handling the results page
        scheduleResultsEnhancement();
      }, false);

    window.onload = function(){ 
      if (document.querySelectorAll('.oct-quiz-wrapper--result-page').length > 0) {
        console.log('landed directly on results?')
        scheduleResultsEnhancement();
      }
    }
    
    function handleResults() {
      try {
        updateQuizStepState();
        enhanceResultsPage();
        console.log('finished quiz!');
      } catch (error) {
        console.warn('Quiz results enhancement skipped:', error);
      }
    }

    function scheduleResultsEnhancement(attempt = 0) {
      window.setTimeout(() => {
        const resultPage = document.querySelector('.oct-quiz-wrapper--result-page');
        const hasProducts = !!(resultPage && resultPage.querySelector('.oct-quiz-product-block'));

        if (!hasProducts && attempt < 20) {
          scheduleResultsEnhancement(attempt + 1);
          return;
        }

        if (hasProducts) {
          handleResults();
        }
      }, attempt === 0 ? 150 : 250);
    }

    function titleFromHandle(handle) {
      if (!handle) return 'Recommended Seeds';
      return handle
        .replace(/-seeds$/, '')
        .replace(/-/g, ' ')
        .replace(/\b\w/g, char => char.toUpperCase());
    }

    function resultDescription(title) {
      const descriptions = {
        'Swiss Chard': 'A fast-growing leafy green, great for salads and cooking.',
        'Carrot': 'A reliable garden staple with colourful, crunchy harvests.',
        'Bush Beans': 'Productive, compact plants for generous summer picking.',
        'Pole Beans': 'Climbing beans that make great use of vertical space.',
        'Tomato': 'A warm-season favourite for containers, beds, and sunny gardens.',
        'Arugula': 'Peppery greens that grow quickly in cool conditions.',
        'Kale': 'Hardy leafy greens for fresh harvests across the season.',
        'Turnip': 'Quick-growing roots with tender greens for kitchen versatility.',
        'Cucumber': 'Refreshing vines and compact types for warm, sunny spaces.',
        'Mustard': 'Flavourful greens that bring colour and spice to the garden.',
        'Squash': 'Bold, productive plants for gardeners with room to sprawl.'
      };
      return descriptions[title] || 'A strong match for your garden conditions and growing goals.';
    }

    function getCollectionForBlock(block) {
      const link = block.querySelector('a[href]');
      if (!link) return { handle: '', links: products };
      const urlParts = link.href.split('/').filter(Boolean);
      const handle = urlParts[urlParts.length - 1] || '';
      return productsObj.find(collection => collection.collectionHandle === handle) || { handle, links: products };
    }

    function setExternalLink(link) {
      link.setAttribute('target', '_blank');
      link.setAttribute('rel', 'noopener noreferrer');
    }

    function enhanceResultCard(block, index) {
      const collection = getCollectionForBlock(block);
      const handle = collection.collectionHandle || collection.handle;
      const title = titleFromHandle(handle);

      block.classList.add('quiz-2026-result-slide');
      block.dataset.quiz2026Slide = String(index);
      block.querySelectorAll('img').forEach((image) => {
        image.setAttribute('draggable', 'false');
      });

      block.querySelectorAll('a[href]').forEach(setExternalLink);

      if (!block.querySelector('.quiz-2026-result-badge')) {
        const imageWrap = block.querySelector('.oct-quiz-top_content');
        const badge = document.createElement('span');
        badge.className = 'quiz-2026-result-badge';
        badge.textContent = 'Recommended';
        if (imageWrap) imageWrap.appendChild(badge);
      }

      if (block.querySelector('.quiz-2026-result-details')) return;

      const details = document.createElement('div');
      details.className = 'quiz-2026-result-details';

      const heading = document.createElement('h3');
      heading.textContent = title;
      details.appendChild(heading);

      const description = document.createElement('p');
      description.textContent = resultDescription(title);
      details.appendChild(description);

      const list = document.createElement('ul');
      list.className = 'product-drop';
      (collection.links || products).slice(0, 6).forEach(([label, href]) => {
        const item = document.createElement('li');
        const itemLink = document.createElement('a');
        itemLink.href = href;
        itemLink.textContent = label;
        setExternalLink(itemLink);
        item.appendChild(itemLink);
        list.appendChild(item);
      });
      details.appendChild(list);
      block.appendChild(details);
    }

    function enhanceResultsPage(root = document) {
      const resultPage = root.querySelector('.oct-quiz-wrapper--result-page');
      if (!resultPage) return;

      const content = resultPage.querySelector('#octane-quiz-wrapper') || resultPage.querySelector('.oct-quiz-content');
      if (!content) return;

      const existingCarousel = content.querySelector(':scope > .quiz-2026-results-carousel');
      const directBlocks = Array.from(content.querySelectorAll(':scope > .oct-quiz-product-block'));
      const trackBlocks = existingCarousel ? Array.from(existingCarousel.querySelectorAll('.oct-quiz-product-block')) : [];
      const blocks = directBlocks.length ? directBlocks : trackBlocks;
      if (!blocks.length) return;

      if (resultPage.dataset.quiz2026ResultsEnhanced !== '1') {
        randomiseFlexOrder(blocks);
      }

      let carousel = existingCarousel;
      let viewport;
      let track;
      let controls;
      let dots;
      let prevButton;
      let nextButton;

      if (!carousel) {
        carousel = document.createElement('div');
        carousel.className = 'quiz-2026-results-carousel';

        viewport = document.createElement('div');
        viewport.className = 'quiz-2026-results-viewport';

        track = document.createElement('div');
        track.className = 'quiz-2026-results-track';

        controls = document.createElement('div');
        controls.className = 'quiz-2026-results-controls';

        prevButton = document.createElement('button');
        prevButton.type = 'button';
        prevButton.className = 'quiz-2026-results-arrow quiz-2026-results-arrow--prev';
        prevButton.setAttribute('aria-label', 'Previous recommendation');
        prevButton.textContent = '‹';

        dots = document.createElement('div');
        dots.className = 'quiz-2026-results-dots';
        dots.setAttribute('aria-label', 'Recommendation slides');

        nextButton = document.createElement('button');
        nextButton.type = 'button';
        nextButton.className = 'quiz-2026-results-arrow quiz-2026-results-arrow--next';
        nextButton.setAttribute('aria-label', 'Next recommendation');
        nextButton.textContent = '›';

        controls.appendChild(prevButton);
        controls.appendChild(dots);
        controls.appendChild(nextButton);
        viewport.appendChild(track);
        carousel.appendChild(viewport);
        carousel.appendChild(controls);

        const subheading = content.querySelector(':scope > .oct-quiz-subheading');
        if (subheading) {
          insertAfter(subheading, carousel);
        } else {
          content.appendChild(carousel);
        }
      } else {
        viewport = carousel.querySelector('.quiz-2026-results-viewport');
        track = carousel.querySelector('.quiz-2026-results-track');
        controls = carousel.querySelector('.quiz-2026-results-controls');
        dots = carousel.querySelector('.quiz-2026-results-dots');
        prevButton = carousel.querySelector('.quiz-2026-results-arrow--prev');
        nextButton = carousel.querySelector('.quiz-2026-results-arrow--next');
      }

      blocks
        .sort((a, b) => (Number(a.style.order) || 0) - (Number(b.style.order) || 0))
        .forEach((block, index) => {
          enhanceResultCard(block, index);
          track.appendChild(block);
        });

      const slides = Array.from(track.querySelectorAll('.oct-quiz-product-block'));
      let activeIndex = Math.min(Number(carousel.dataset.quiz2026Active || 0), slides.length - 1);
      const mobileResultsQuery = window.matchMedia('(max-width: 560px)');

      function isMobileResults() {
        return mobileResultsQuery.matches;
      }

      function normalizeIndex(index) {
        if (!slides.length) return 0;
        return (index + slides.length) % slides.length;
      }

      function renderCarousel(index) {
        activeIndex = normalizeIndex(index);
        carousel.dataset.quiz2026Active = String(activeIndex);

        slides.forEach((slide, slideIndex) => {
          const offset = slideIndex - activeIndex;
          const wrappedOffset = offset > slides.length / 2
            ? offset - slides.length
            : offset < -slides.length / 2
              ? offset + slides.length
              : offset;

          slide.classList.toggle('is-active', wrappedOffset === 0);
          slide.classList.toggle('is-prev', wrappedOffset === -1);
          slide.classList.toggle('is-next', wrappedOffset === 1);
          slide.classList.toggle('is-hidden', Math.abs(wrappedOffset) > 1);
          slide.setAttribute('aria-hidden', wrappedOffset === 0 ? 'false' : 'true');
        });

        dots.querySelectorAll('button').forEach((dot, dotIndex) => {
          dot.classList.toggle('is-active', dotIndex === activeIndex);
          dot.setAttribute('aria-current', dotIndex === activeIndex ? 'true' : 'false');
        });
      }

      dots.innerHTML = '';
      slides.forEach((slide, index) => {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.setAttribute('aria-label', `Show recommendation ${index + 1}`);
        dot.addEventListener('click', () => renderCarousel(index));
        dots.appendChild(dot);
      });

      if (carousel.dataset.quiz2026CarouselBound !== '1') {
        prevButton.addEventListener('click', () => renderCarousel(activeIndex - 1));
        nextButton.addEventListener('click', () => renderCarousel(activeIndex + 1));

        track.addEventListener('click', (event) => {
          const slide = event.target.closest('.oct-quiz-product-block');
          if (slide && isMobileResults()) {
            if (event.target.closest('.quiz-2026-result-close')) {
              event.preventDefault();
              event.stopPropagation();
              slide.classList.remove('is-mobile-open');
              slide.querySelector('.quiz-2026-result-toggle')?.setAttribute('aria-expanded', 'false');
              return;
            }

            if (!slide.classList.contains('is-mobile-open')) {
              event.preventDefault();
              event.stopPropagation();
              slides.forEach((otherSlide) => {
                if (otherSlide !== slide) {
                  otherSlide.classList.remove('is-mobile-open');
                  otherSlide.querySelector('.quiz-2026-result-toggle')?.setAttribute('aria-expanded', 'false');
                }
              });
              slide.classList.add('is-mobile-open');
              slide.querySelector('.quiz-2026-result-toggle')?.setAttribute('aria-expanded', 'true');
              return;
            }

            return;
          }

          if (slide && !slide.classList.contains('is-active')) {
            event.preventDefault();
            event.stopPropagation();
            renderCarousel(slides.indexOf(slide));
            return;
          }
        }, true);

        carousel.dataset.quiz2026CarouselBound = '1';
      }

      slides.forEach((slide, index) => {
        if (!slide.querySelector('.quiz-2026-result-toggle')) {
          const toggle = document.createElement('button');
          toggle.type = 'button';
          toggle.className = 'quiz-2026-result-toggle';
          toggle.setAttribute('aria-label', 'Open recommendation');
          toggle.setAttribute('aria-expanded', slide.classList.contains('is-mobile-open') ? 'true' : 'false');
          slide.appendChild(toggle);
        }

        if (!slide.querySelector('.quiz-2026-result-close')) {
          const close = document.createElement('button');
          close.type = 'button';
          close.className = 'quiz-2026-result-close';
          close.setAttribute('aria-label', 'Close recommendation');
          close.textContent = '×';
          slide.appendChild(close);
        }

        slide.style.setProperty('--quiz-2026-mobile-order', String(index + 1));
      });

      resultPage.dataset.quiz2026ResultsEnhanced = '1';
      renderCarousel(activeIndex);
    }
    
    //MUTATION OBSERVERS TO ADD NAME AND OTHER CUSTOM PROPERTIES INTO OCTANE SECTION CONTENT
    function waitForElm(selector) {
        return new Promise(resolve => {
            if (document.querySelector(selector)) {
                return resolve(document.querySelector(selector));
            }

            const observer = new MutationObserver(mutations => {
                if (document.querySelector(selector)) {
                    resolve(document.querySelector(selector));
                    observer.disconnect();
                }
            });

            observer.observe(document.body, {
                childList: true,
                subtree: true
            });
        });
    }
    let suppliedName;
    let backToQuestion = false;
    function clickBack() {
      let backButton = document.querySelector('.oct-quiz-btn--small');
      if (!backButton) return;
      backToQuestion = false;
      backButton.click();
    }
    function backToPriorQuestion() {
      if (backToQuestion) {
        let backButton = document.querySelector('.oct-quiz-btn--small');
        backButton.click();
      }
    }
    
    // waitForElm('.oct-quiz-wrapper--collect-text .oct-quiz-btn--primary').then((elm) => {
    //     watchOctaneChanges(elm)
    // });
    function watchOctaneChanges(element) {
      if (!element || element.dataset.quiz2026NameBound === '1') return;
      let nameInput = document.querySelector('.oct-quiz-collect-text-wrapper input');
      if (!nameInput) return;
      element.dataset.quiz2026NameBound = '1';
      console.log('Name input is ready');
      element.addEventListener("click", function() {
         suppliedName = nameInput.value;
         console.log('captured username: ', suppliedName);
      });
      waitForElm('.oct-quiz-wrapper--explainer').then((elm2) => {
        insertUserName(elm2);
      });
    }
    function insertUserName(element) {
      console.log('Name explainer section up') ;
      let nameTitle = element.querySelector('.oct-quiz-title');
      if (suppliedName && !nameTitle.textContent.includes(suppliedName)) {
        nameTitle.textContent = suppliedName + ", " + nameTitle.textContent.toLocaleLowerCase();
      }
    }

    var explainerObserver = new MutationObserver(function(mutations) {
      ensureQuizSectionWrapped();
      let explainerWrapper = document.querySelector('.oct-quiz-wrapper--explainer');
      let pictureQWrapper = document.querySelector('.oct-quiz-wrapper--picture-choice');
      if (explainerWrapper != null) {
          console.log("explainer section up");
          let nameTitle = document.querySelector('.oct-quiz-title');
          if (nameTitle.textContent.toLocaleLowerCase().includes("true gardener's name")) {
            console.log('name title section...inserting name');
            backToQuestion = false;
            if (suppliedName && !nameTitle.textContent.includes(suppliedName)) {
              nameTitle.textContent = suppliedName + ", " + nameTitle.textContent.toLocaleLowerCase();
            }
          } else if (nameTitle.textContent.toLocaleLowerCase().includes("going anonymous")) {
            console.log('name input skipped...going anon');
            backToQuestion = false;
          } else if (backToQuestion) {
            clickBack();
          } else if (!isAutoAdvanceExplainer(explainerWrapper) && document.querySelectorAll('.auto-loader').length < 1 && !explainerWrapper.querySelector('.oct-quiz-top_content img')) {
            console.log('assuming comment section...adding loader');
            let autoLoader = document.createElement('div');
            autoLoader.classList.add('auto-loader');
            insertAfter(nameTitle, autoLoader);
          }
          enhanceExplainerVisuals();
          normalizeQuizButtonText();
          enhanceExplainerBackButtons();
          // newObserver.disconnect();
          //We can disconnect observer once the element exist if we dont want observe more changes in the DOM
      } else if (pictureQWrapper != null) {
        console.log("question section up");
        backToQuestion = false;
        //listen for back button
        let backButton = document.querySelector('.oct-quiz-btn--small');
        if (backButton && backButton.dataset.quiz2026BackBound !== '1') {
          backButton.dataset.quiz2026BackBound = '1';
          backButton.addEventListener('click', function() {
            console.log('back clicked!');
            backToQuestion = true;
          });
        }
      }
    });
    // Start observing
    explainerObserver.observe(document.body, { //document.body is node target to observe
        childList: true, //This is a must have for the observer with subtree
        subtree: true //Set to true if changes must also be observed in descendants.
    });

    var nameInputObserver = new MutationObserver(function(mutations) {
      ensureQuizSectionWrapped();
      let collectTextWrapper = document.querySelector('.oct-quiz-wrapper--collect-text');
      let nameInput = collectTextWrapper && collectTextWrapper.querySelector('.oct-quiz-collect-text-wrapper input');
      let continueButton = collectTextWrapper && collectTextWrapper.querySelector('.oct-quiz-btn-wrapper .oct-quiz-btn--primary, .quiz-btns-wrapper .oct-quiz-btn--primary');
      if (nameInput != null && continueButton != null && continueButton.dataset.quiz2026NameBound !== '1') {
          continueButton.dataset.quiz2026NameBound = '1';
          console.log("Name input is ready");
          continueButton.addEventListener("click", function() {
             suppliedName = nameInput.value;
             console.log('captured username: ', suppliedName);
          });
          // newObserver.disconnect();
          //We can disconnect observer once the element exist if we dont want observe more changes in the DOM
      }
    });
    // Start observing
    nameInputObserver.observe(document.body, { //document.body is node target to observe
        childList: true, //This is a must have for the observer with subtree
        subtree: true //Set to true if changes must also be observed in descendants.
    });
})
